/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 08/12/2024 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import Autocomplete from "../ui/Autocomplete";
import { apiConceptosYGruposList, apiBuscarApartadosList } from "../../settings/ApiConfig"

import react, { useEffect, useState, Fragment, forwardRef, useImperativeHandle } from 'react'
import { Button, Modal, Box, MenuItem, Typography, InputAdornment } from "@mui/material";
import PersonIcon from "@mui/icons-material/PersonOutlineSharp";
import GroupsIcon from '@mui/icons-material/Groups';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import DescriptionIcon from '@mui/icons-material/Description';

import { useRequest } from "../../context/System/RequestContext";
import { useLayout } from "../../context/System/LayoutContext";

import SizeSoftXTableVentas from "../leyout/SizeSoftXTableVentas"

export default function FrmListaApartadosDetalles(props) {
    const { rowApartado, inputFocusRef } = props;

    const { handleOpenAlert } = useLayout();

    const { GetRequest, PostRequest } = useRequest()
    const [listaConceptosAgrupados, setListaConceptosAgrupados] = useState([]);
    const [listaGrupos, setListaGrupos] = useState([]);

    const [listaData, setListaData] = useState([]);
    const [partidaSeleccionada, setPartidaSeleccionada] = useState({});

    const [listaConceptos, setListaConceptos] = useState([{
        concepto:"",
        grupo:"",
    }]); 


    const [detalles, setDetalles] = useState({
        nombrecliente:"",
        concepto:"",
        grupo:"",
        descripcion:"",
        medida:0,
    });

    const handleBuscarApartados=async(entity)=>{
        if(entity.nombrecliente.length===0 && entity.concepto.length===0 && entity.grupo.length===0 && entity.medida===0 && entity.descripcion.length===0)
            {
                setListaData([]);
                setListaGrupos([]);
                return;
            }

        //var data = JSON.stringify(entity);
        const response = await PostRequest({
            url: apiBuscarApartadosList,
            body:entity,
            alert:"Se esté realizando la búsqueda de apartados"
        });

        if(response.hasError)
        {
            handleOpenAlert("Error al obtener lista de apartados","error");
            setListaData([]);
            return;
        }

        setListaGrupos([]);
        setListaData(response?.result ? response?.result : []);
    };
        
    const handleChangePartidaSeleccionada =(e)=>{
        setPartidaSeleccionada(e);
        rowApartado(e);
    };
     
    const handleObtenerListaConceptosSistema = async() => {
        const response = await GetRequest({
            url: apiConceptosYGruposList,
            loader: "Obteniendo listado de conceptos del sistema..."
        });

        if (response.hasError)
        {
            handleOpenAlert(response.message);
            return;
        }        

        const listaX = response?.result || [];
        setListaConceptos(listaX);

        const listaConceptosAgrupadosX = listaX.reduce((acc, item) => {
            const { concepto } = item;
            if (!acc[concepto]) {
                acc[concepto] = item; // Guarda solo el primer elemento único
            }
            return acc;
        }, {});

        const conceptosAgrupadosArray = Object.values(listaConceptosAgrupadosX); //Esto convierte a un array el resultado

        setListaConceptosAgrupados(conceptosAgrupadosArray);
        setListaGrupos([]);
    };

    const handleCargarGruposPorConcepto = (conceptoSeleccionado) => {
        if (!conceptoSeleccionado || typeof conceptoSeleccionado !== 'string') 
            {
                setListaGrupos([]);
                return;
            }

        // Buscar los elementos que coincidan con el concepto seleccionado
        const listaGruposX = listaConceptos
            .filter(item => (item.concepto || '').toString().trim().includes((conceptoSeleccionado || '').toString().trim()));
    
        const listaGruposAgrupadosX = listaGruposX.reduce((acc, item) => {
            const { grupo } = item;
            if (!acc[grupo]) {
                acc[grupo] = item; // Guarda solo el primer elemento único
            }
            return acc;
        }, {});

        const gruposArray = Object.values(listaGruposAgrupadosX);

        // Actualizar el estado con los grupos encontrados
        setListaGrupos(gruposArray);
    };
    
    const handleChangeDetalles = (e) => {
        if(e.target.value === null || e.target.value === undefined)
            return;

        if(e.target.name === "medida" && String(e.target.value).trim() === "")
        {
            e.target.value=0;
        }

        setDetalles(prevDetalles => ({
            ...prevDetalles,
            [e.target.name]: e.target.value
        }));
    };

    const handleEnterKey = (event) => {
        if (event.key === 'Enter') {            
            handleBuscarApartados(detalles);
        }
    };

    const listaConceptosByOrder = listaConceptosAgrupados.slice().sort((a, b) => a.concepto.localeCompare(b.concepto));
    const listaGruposByOrder = listaGrupos.slice().sort((a, b) => a.grupo.localeCompare(b.grupo));

    useEffect(() => {
        handleObtenerListaConceptosSistema();
    },[]);

    useEffect(() => {
        handleCargarGruposPorConcepto(detalles.concepto);
    },[detalles.concepto]);

    return(
        <>
            <Fragment>
                <div className="body-Detalles">
                    <div className="container-data-filter">
                        <TextField
                            inputRef={inputFocusRef}
                            name="nombrecliente"
                            label="Filtro nombre cliente:"
                            value={detalles.nombrecliente}
                            onFocus={(e) => e.target.select()}
                            onChange={handleChangeDetalles} 
                            onKeyDown={handleEnterKey}
                            type="text"
                            autoComplete="off"
                            inputProps={{ maxLength: 60, minLength: 5 }}
                            sx={{
                                margin: '.1rem .1rem',
                                width: '99%',
                                height: '2.5rem', // Altura específica del contenedor
                                '& .MuiInputBase-root': {
                                    height: '2rem', // Altura interna del campo de entrada
                                    fontSize: '1rem', // Ajusta el tamaño del texto
                                },
                                '& .MuiFormLabel-root': {
                                    fontSize: '0.85rem', // Ajusta el tamaño de la etiqueta
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PersonIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Autocomplete
                            value={detalles.concepto || ""}
                            inputValue={detalles.concepto || ""}
                            onChange={(event, newValue) => handleChangeDetalles({ target: { name: 'concepto', value: newValue } })}                            
                            onInputChange={(event, newInputValue) => handleChangeDetalles({ target: { name: 'concepto', value: newInputValue } })}
                            onKeyDown={handleEnterKey}
                            options={listaConceptosByOrder.map(concepto => concepto.concepto)} // Lista de opciones
                            autoComplete="off"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Conceptos de apartado:"
                                    sx={{
                                        margin: '.1rem .1rem',
                                        width: '99%',
                                        height: '2.5rem', // Altura específica del contenedor
                                        '& .MuiInputBase-root': {
                                            height: '2rem', // Altura interna del campo de entrada
                                            fontSize: '1rem', // Ajusta el tamaño del texto
                                        },
                                        '& .MuiFormLabel-root': {
                                            fontSize: '0.85rem', // Ajusta el tamaño de la etiqueta
                                        },
                                    }}                                           
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <HistoryEduIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}
                            freeSolo // Permite escribir texto libre ademés de las opciones sugeridas
                        />
                        <Autocomplete
                            value={detalles.grupo || ""}
                            inputValue={detalles.grupo || ""}
                            onChange={(event, newValue) => handleChangeDetalles({ target: { name: 'grupo', value: newValue } })}                            
                            onInputChange={(event, newInputValue) => handleChangeDetalles({ target: { name: 'grupo', value: newInputValue } })}
                            onKeyDown={handleEnterKey}                            
                            options={listaGruposByOrder.map(grupo => grupo.grupo)} // Lista de opciones
                            autoComplete="off"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Grupos por concepto:"
                                    sx={{
                                        margin: '.1rem .1rem',
                                        width: '99%',
                                        height: '2.5rem', // Altura específica del contenedor
                                        '& .MuiInputBase-root': {
                                            height: '2rem', // Altura interna del campo de entrada
                                            fontSize: '1rem', // Ajusta el tamaño del texto
                                        },
                                        '& .MuiFormLabel-root': {
                                            fontSize: '0.85rem', // Ajusta el tamaño de la etiqueta
                                        },
                                    }}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <GroupsIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}
                            freeSolo // Permite escribir texto libre ademés de las opciones sugeridas
                        />                   
                        <TextField
                            name="descripcion"
                            label="Filtro descripción artículo:"
                            value={detalles.descripcion}
                            onFocus={(e) => e.target.select()}
                            onChange={handleChangeDetalles} 
                            onKeyDown={handleEnterKey}
                            type="text"
                            autoComplete="off"
                            inputProps={{ maxLength: 60, minLength: 5 }}
                            sx={{
                                margin: '.1rem .1rem',
                                width: '99%',
                                height: '2.5rem', // Altura específica del contenedor
                                '& .MuiInputBase-root': {
                                    height: '2rem', // Altura interna del campo de entrada
                                    fontSize: '1rem', // Ajusta el tamaño del texto
                                },
                                '& .MuiFormLabel-root': {
                                    fontSize: '0.85rem', // Ajusta el tamaño de la etiqueta
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <DescriptionIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            name="medida"
                            label="Filtro medida:"
                            value={detalles.medida}
                            onFocus={(e) => e.target.select()}
                            onChange={handleChangeDetalles} 
                            onKeyDown={handleEnterKey}
                            type="text"
                            autoComplete="off"
                            inputProps={{ maxLength: 4, minLength: 1 }}
                            sx={{
                                margin: '.1rem .1rem',
                                width: '40%',
                                height: '2.5rem', // Altura específica del contenedor
                                '& .MuiInputBase-root': {
                                    height: '2rem', // Altura interna del campo de entrada
                                    fontSize: '1rem', // Ajusta el tamaño del texto
                                },
                                '& .MuiFormLabel-root': {
                                    fontSize: '0.85rem', // Ajusta el tamaño de la etiqueta
                                },
                            }}                       
                        />
                    </div>
                    <div className="container-data-filter">
                        <SizeSoftXTableVentas
                            columns={[
                                { title: "Nombre cliente", field: "nombrecliente" },
                                { title: "Descripción", field: "descripcion" },
                                { title: "Medida", field: "medida" },
                                { title: "Apartado", field: "folioapartado" },
                            ]}
                            data={listaData == null ? []:listaData} 
                            id="id"
                            row={partidaSeleccionada}
                            setRow={handleChangePartidaSeleccionada}
                            fontSize="small"    
                            rowsPerPageIntro={50}                        
                        />  
                    </div>
                </div>
            </Fragment>
        </>
    )
}
